import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import SectionHeader from './SectionHeader';
import about from '../../../assets/aboutImage.png';

import css from './Sections.module.css';

/** Our story: on a light grey band before the footer, ending with two next steps. */
function SectionAboutUs(props) {
  const { intl } = props;
  return (
    <section className={css.aboutBand}>
      <div className={css.container}>
        <div className={css.about}>
          <img className={css.aboutImage} src={about} alt="" />
          <div className={css.aboutText}>
            <SectionHeader
              eyebrow={intl.formatMessage({ id: 'SectionAboutUs.eyebrow' })}
              title={intl.formatMessage({ id: 'SectionAboutUs.title' })}
            />
            <p className={css.aboutBody}>
              <FormattedMessage id="SectionAboutUs.descriptionParagraph1" />
            </p>
            <p className={css.aboutBody}>
              <FormattedMessage id="SectionAboutUs.descriptionParagraph2" />
            </p>
            <p className={css.aboutClosing}>
              <FormattedMessage id="SectionAboutUs.descriptionParagraph3" />
            </p>
            <div className={css.aboutActions}>
              <NamedLink name="SearchPage" className={css.buttonPrimary}>
                <FormattedMessage id="SectionAboutUs.browse" />
              </NamedLink>
              <NamedLink name="PurchaseProtectionPage" className={css.headerLink}>
                <FormattedMessage id="SectionAboutUs.protection" />
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
                  <path d="M5 12h14M13 6l6 6-6 6" />
                </svg>
              </NamedLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SectionAboutUs;
